import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, getStandaloneReport } from "./actions";
import MapContainer from "./MapContainer";
import { StyledHeader } from "../../styles";
import {
    Card,
    CardContent,
    Button,
    Typography,
    Table,
    TableBody,
    TableRow,
    Grid
} from "@material-ui/core";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { selectCurrentReport } from "./selectors";
import ReactToPrint from "react-to-print";
import { gridStyle, cellStyle } from "../gridHelper";
import "../imgDiv.css";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { cellStyle as cstyle } from "../gridHelper";
import PrintIcon from "@material-ui/icons/Print";
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';

class WalkaroundReport extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getStandaloneReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        }
        else {
            props.getReport(
                path[6],
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
        this.state = {
            reportRetrieved: false,
            report: [],
            imageModal: false,
            selectedImg: false
        };
    }
    componentDidUpdate(prevState) {
        if (prevState.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }

    renderSigs(attachedSigs) {
        let sigRow = 2;
        let sigCell = 1;
        let ref = "";
        return attachedSigs.map((sig, i) => {
            if (sig.signature_url.includes("https:") === false) {
                ref = "data:image/png;base64," + sig.signature_url
            }
            let sigInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cstyle(
                            sigRow,
                            sigCell,
                            sigRow,
                            sigCell,
                            true
                        )}
                    >
                        {sig.signature_name}
                    </div>
                    <div
                        style={cstyle(
                            sigRow,
                            sigCell + 1,
                            sigRow,
                            sigCell + 1,
                            true
                        )}
                    >
                        {sig.signature_timestamp}
                    </div>
                    {sig.signature_url.includes("https:")
                        ?
                        <div
                            style={cstyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={sig.signature_url}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        imageModal: true,
                                        selectedImg: sig.signature_url
                                    })
                                }}
                                style={{
                                    width: 300,
                                    height: "140px",
                                    margin: "auto",
                                    cursor: "pointer"
                                }}
                            />
                        </div>
                        :

                        <div
                            style={cstyle(
                                sigRow + 1,
                                sigCell,
                                sigRow + 1,
                                sigCell + 2
                            )}
                        >
                            <img
                                src={ref}
                                alt="Site "
                                onClick={() => {
                                    this.setState({
                                        imageModal: true,
                                        selectedImg: ref
                                    })
                                }}
                                style={{
                                    width: 300,
                                    height: 300,
                                    margin: "auto",
                                    cursor: "pointer"
                                }}
                            />
                        </div>

                    }
                </React.Fragment>
            );
            sigCell += 2;
            if (sigCell === 9) {
                sigRow += 2;
                sigCell = 1;
            }
            return sigInfo;
        });
    }

    renderStatus(status){
        if(status === 'Red'){
            return( <FiberManualRecordRoundedIcon style={{color:"red"}}/>);
        }
        if(status === 'Amber'){
            return( <FiberManualRecordRoundedIcon style={{color:"#FFBF00"}}/>);
        }
        if(status === 'Green'){
            return( <FiberManualRecordRoundedIcon style={{color:"green"}}/>);
        }
        if(status === 'N/A'){
            return(<FiberManualRecordRoundedIcon style={{color:"#83878d"}}/>);
        }   
    }

    renderStatusCount(){
        let issue_counts = {};
        if(this.props.report.sections){
            let sections = Object.values(this.props.report.sections);
            let green_issue_counts = 0;
            let red_issue_counts = 0;
            let amber_issue_counts = 0;
            let grey_issue_counts = 0;
            for(var c = 0 ; c < sections.length ; c++){
                let section = {}
                section = sections[c]
                for(var d = 0 ; d < section.items.length ; d++){
                    let issue = {};
                    issue = section.items[d]
                    if(issue.status === 'Red'){
                        red_issue_counts = red_issue_counts + 1;
                    }
                    if(issue.status === 'Green'){
                        green_issue_counts = green_issue_counts + 1;
                    }
                    if(issue.status === 'Amber'){
                        amber_issue_counts = amber_issue_counts + 1;
                    }
                    if(issue.status === 'N/A'){
                        grey_issue_counts = grey_issue_counts + 1;
                    }
                }
            }
            issue_counts['red'] = red_issue_counts;
            issue_counts['green'] = green_issue_counts;
            issue_counts['amber'] = amber_issue_counts;
            issue_counts['grey'] = grey_issue_counts;
        }
        
        
        
        return issue_counts;
    }


    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const cstyle = cellStyle;
        const gstyle = gridStyle;
        let color = this.props.color;
        let issueCounts = this.renderStatusCount();
        console.log(issueCounts, "issueCounts")
        return (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>Walkaround Inspection Report
                    <ReactToPrint
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                            }}
                            trigger={() => (
                                <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor: "pointer"
                                    }}
                                />
                            )}
                            content={() => this.componentRef}
                        />
                    </Typography>
                </StyledHeader>
                <CardContent>
                    {report && (

                        <div ref={el => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}
                            <Grid container spacing={3}>
                                <Grid item xs={8}>
                                    <div style={gstyle(7, 13, null, color)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Inspection Details</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 7)}>
                                            <b>Name:</b>&nbsp;{report.user_name
                                                ? report.user_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(2, 7, 2, 13, true)}>
                                            <b>Email:</b>&nbsp;{report.user_email
                                                ? report.user_email
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 7)}>
                                            <b>Driver Name:</b>&nbsp;{report.driver_name
                                                ? report.driver_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(3, 7, 3, 13, true)}>
                                            <b>Crew Name:</b>&nbsp;{report.crew_name
                                                ? report.crew_name
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 1, 4, 7)}>
                                            <b>Vehicle Reg No.:</b> &nbsp; {report.vehicle_reg
                                                ? report.vehicle_reg
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(4, 7, 4, 13, true)}>
                                            <b>Vehicle Nickname:</b>&nbsp;{report.vehicle_nickname
                                                ? report.vehicle_nickname
                                                : "N/A"}
                                            {/* <b>Form Created:&nbsp;{report.timestamp
                                                ? report.timestamp
                                                : "N/A"}</b> */}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 7)}>
                                            <b>Longitude:</b>&nbsp; {report.location_lon
                                                ? report.location_lon
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(5, 7, 5, 13, true)}>
                                            <b>Latitude:</b>&nbsp;{report.location_lat
                                                ? report.location_lat
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 7)}>
                                            <b>Inspection Start:</b>&nbsp;{report.inspection_start_timestamp
                                                ? report.inspection_start_timestamp
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(6, 7, 6, 13, true)}>
                                            <b>Odometer Reading:</b>&nbsp;{report.vehicle_odometer_reading
                                                ? report.vehicle_odometer_reading
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 7)}>
                                            <b>Inspection Template:</b>&nbsp;{report.template_uid
                                                ? report.template_uid.substring(6).replace(/_/g, ' ')
                                                : "N/A"}
                                        </div>
                                        <div style={cstyle(7, 7, 7, 13, true)}>
                                            <b>Inspection Duration:</b>&nbsp;{report.inspection_duration_type
                                                ? report.inspection_duration_type
                                                : "N/A"}
                                        </div>
                                        {/* <div style={cstyle(8, 1, 8, 7)}>
                                            <b>Inspection Result:&nbsp;{report.inspection_result
                                                ? report.inspection_result
                                                : "N/A"}</b>
                                        </div>
                                        <div style={cstyle(8, 7, 8, 13, true)}>
                                            <b>Registered in System:&nbsp;{report.vehicle_registered_in_system
                                                ? report.vehicle_registered_in_system
                                                : "N/A"}</b>
                                        </div> */}
                                    </div>
                                </Grid>
                                <Grid item xs={4}>
                                    <div>
                                        <StyledHeader style={{ background: "#0188cc" }}>
                                            <Typography variant="body1" style={{ color: "white" }}>Report Location
                                    </Typography></StyledHeader>
                                        <MapContainer
                                            lat={+report.location_lat}
                                            long={+report.location_lon}
                                        //style={{ width: "80%" }}
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            <br /><br />
                            <div style={{ border: "0.5px solid #0188cc" }}>
                                <h3 style={{
                                    backgroundColor: "#0188cc",
                                    textAlign: "left",
                                    padding: "4px",
                                    fontWeight: "bold",
                                    color: "white",
                                    fontSize: "22px"
                                }}>
                                    Rating Details
                                </h3>
                                <Grid container spacing={3} style={{ margin: "5px" }}>
                                    <Grid item xs={3} style={{ paddingLeft: "30px" }}>
                                        <Row>
                                            Green
                                    </Row>
                                        <Row>
                                            Amber
                                    </Row>
                                        <Row>
                                            Red
                                    </Row>
                                        <Row>
                                            Grey
                                    </Row>
                                    </Grid>
                                    <Grid item xs={3} style={{ paddingLeft: "30px" }}>
                                        <Row>
                                            <FiberManualRecordIcon style={{ color: "green" }} />
                                        </Row>
                                        <Row>
                                            <FiberManualRecordIcon style={{ color: "#FFBF00" }} />
                                        </Row>
                                        <Row>
                                            <FiberManualRecordIcon style={{ color: "red" }} />
                                        </Row>
                                        <Row>
                                            <FiberManualRecordIcon style={{ color: "grey" }} />
                                        </Row>
                                    </Grid>
                                    <Grid item xs={3} style={{ paddingLeft: "30px" }}>
                                        <Row>
                                            No Defects
                                        </Row>
                                        <Row>
                                            Temporary Fix Required
                                        </Row>
                                        <Row>
                                            Unroadworthy
                                        </Row>
                                        <Row>
                                            N/A
                                        </Row>
                                    </Grid>
                                    <Grid item xs={3} style={{ paddingLeft: "30px" }}>
                                        <Row>
                                           {issueCounts['green']}
                                        </Row>
                                        <Row>
                                           {issueCounts['amber']}
                                        </Row>
                                        <Row>
                                           {issueCounts['red']}
                                        </Row>
                                        <Row>
                                           {issueCounts['grey']}
                                        </Row>
                                    </Grid>

                                </Grid>
                            </div>

                            <div style={{ marginTop: "10px" }}>
                                <h3 style={{
                                    backgroundColor: "#0188cc",
                                    textAlign: "left",
                                    padding: "4px",
                                    fontWeight: "bold",
                                    color: "white",
                                    fontSize: "22px"
                                }}>
                                    Inspection Sections
                                </h3>
                               

                                {report.sections && report.sections.map((e, i) => {

                                    let issue_count = 0
                                    for(var x = 0 ; x < e.items.length ; x++){
                                        let issue = {};
                                        issue = e.items[x]
                                        if(issue.status === 'Red'){
                                            issue_count = issue_count + 1;
                                        }
                                    }

                                    return (
                                        <ExpansionPanel>
                                            <ExpansionPanelSummary
                                                expandIcon={<ExpandMoreIcon style={{color:"white"}}/>}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                style={{ backgroundColor: "#0188cc", 
                                                         borderRadiusTopRight: "6px",
                                                         borderRadiusTopLeft: "6px" ,
                                                         fontSize: "15px",color:"white"
                                                }}
                                            >{e.profile.title} - {issue_count} issues
                                            </ExpansionPanelSummary>
                                            <div style={{border:"0.5px solid #0188cc"}}>
                                                <Table>
                                                    <TableBody>
                                                        <TableRow key={i}>
                                                            <div className="icon-text-container">
                                                                <div>
                                                                    {e.items && e.items.map((k, j) => {
                                                                        return (
                                                                            <Grid container spacing={3}>
                                                                                <Grid item xs={2}>
                                                                                    {typeof k.item_icon === "undefined" ?
                                                                                    <>
                                                                                        <img
                                                                                            className="customNameImgStyle"
                                                                                            src={require("./icons/custom_inspection_check_icon.png")}
                                                                                            alt="Site"
                                                                                            style={{ height: "60px", width: "60px", margin: "10px" }}

                                                                                        />
                                                                                    </>
                                                                                    :
                                                                                    <img
                                                                                        className="customNameImgStyle"
                                                                                        src={k.item_icon}
                                                                                        alt="Site"
                                                                                        style={{ height: "60px", width: "60px", margin: "10px" }}
                                                                                        onClick={() => {
                                                                                            this.setState({
                                                                                                imageModal: true,
                                                                                                selectedImg: k.item_icon
                                                                                            })
                                                                                        }}
                                                                                    />

                                                                                    }
                                                                                </Grid>
                                                                                <Grid item xs={3}>
                                                                                    <b>Question: </b>{k.item_title}
                                                                                </Grid>
                                                                                <Grid item xs={3}>
                                                                                    <b>Defect:</b> {k.defect ? k.defect : "N/A"}<br />
                                                                                    <b>Temp Fix: </b> {k.temp_fix ? k.temp_fix : "N/A"}
                                                                                </Grid>
                                                                                <Grid item xs={2}>
                                                                                {k.photo_url === "" ? ""
                                                                                 :
                                                                                 <img
                                                                                    src={k.photo_url}
                                                                                    alt="Site "
                                                                                    style={{
                                                                                        width: "100px",
                                                                                        height: "100px",
                                                                                        margin: "auto",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        this.setState({
                                                                                            imageModal: true,
                                                                                            selectedImg: k.photo_url
                                                                                        })
                                                                                    }}
                                                                                />
                                                                                }
                                                                                </Grid>
                                                                                <Grid item xs={2}>
                                                                                    <p>{this.renderStatus(k.status)}</p>
                                                                                </Grid>
                                                                            </Grid>
                                                                            
                                                                        );
                                                                    })}
                                                                </div>
                                                                <div className="clear"></div>
                                                            </div>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        </ExpansionPanel>
                                    );
                                })}

                                <br />
                                <div style={{ clear: "both", border: "2px solid #0188cc", borderRadius: "6px", marginLeft: "5px", marginTop: "10px" }}>
                                    <h1 style={{
                                        backgroundColor: "#0188cc",
                                        textAlign: "center",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        color: "white",
                                        fontSize: "22px"
                                    }}>
                                        Inspection Summary
                                </h1>
                                    <div style={{
                                        display: "flex",
                                        backgroundColor: report.inspection_result === "Clear"
                                            ? "green"
                                            : report.inspection_result === "Do Not Use"
                                                ? "red"
                                                : "yellow",
                                        // backgroundColor: "green",
                                        color: report.inspection_result === "Clear"
                                            ? "white"
                                            : report.inspection_result === "Do Not Use"
                                                ? "white"
                                                : "black",
                                        height: "62px",
                                        paddingTop: "12px"
                                    }}
                                    >
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "322px",
                                                    marginLeft: "5px"
                                                }}
                                            >
                                                <b>Inspection Result:</b> <span className="subHeading">{report.inspection_result}</span>
                                            </h5>
                                        </span>
                                        <span>
                                            <h5
                                                style={{
                                                    fontSize: "1em",
                                                    padding: "7px",
                                                    textAlign: "left",
                                                    width: "300px",
                                                    marginLeft: "5px"
                                                }}
                                            >
                                                <b>Machine Registered in System:</b> <span className="subHeading">{report.vehicle_registered_in_system}</span>
                                            </h5>
                                        </span>
                                    </div>
                                </div>
                                <br />
                                <br />
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Inspector Signatures</b>
                                    </div>
                                    {report.attached_inspector_signature &&
                                        this.renderSigs(
                                            report.attached_inspector_signature
                                        )}
                                </div>
                                <br />
                                <div style={gstyle(4, 9, null)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Manager/Supervisor Signatures</b>
                                    </div>
                                    {report.attached_supervisor_manager_signature &&
                                        this.renderSigs(
                                            report.attached_supervisor_manager_signature
                                        )}
                                </div>
                            </div>
                        </div>
                    )}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Image Details</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={

                                        this.state.selectedImg
                                            ? this.state.selectedImg
                                            : noImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: "",
                                            imageModal: false
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            report: selectCurrentReport(store)
        };
    },
    { getReport, getStandaloneReport }
)(WalkaroundReport);
